import Image from 'next/image';

export const InlineImageBlock = (props: any) => {
  const { image, width, height } = props;

  return (
    <Image
      className="inline-flex overflow-hidden rounded-md"
      src={image.url!}
      width={width}
      height={height}
      alt={image.alt}
    />
  );
};
